
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8 7a5 5 0 100 10h1a1 1 0 110 2H8A7 7 0 118 5h1a1 1 0 010 2H8zm7-1a1 1 0 011-1 7 7 0 110 14h-1a1 1 0 110-2h1a5 5 0 100-10 1 1 0 01-1-1z","fill":"url(#paint0_linearLinkGradient)"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8 12a1 1 0 011-1h6a1 1 0 110 2H9a1 1 0 01-1-1z","fill":"url(#paint1_linearLinkGradient)"}}),_c('defs',[_c('linearGradient',{attrs:{"id":"paint0_linearLinkGradient","x1":"2.329","y1":"18.264","x2":"14.012","y2":".652","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#9C27B0"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#9733EE"}})]),_c('linearGradient',{attrs:{"id":"paint1_linearLinkGradient","x1":"8.483","y1":"12.895","x2":"9.367","y2":"9.502","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#9C27B0"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#9733EE"}})])])])
          )
        }
      }
    